import generateStore from './generateStore.js'
import humps from 'humps'
import { axios } from '../request'

function processParams(params) {
  const p = JSON.parse(JSON.stringify(params))
  if (typeof params.sort.name === 'undefined') {
    p.sortName = 'created_at'
  } else {
    p.sortName = params.sort.name
  }
  if (typeof params.sort.direction === 'undefined') {
    p.sortDir = ''
  } else if (params.sort.direction === 'ascending') {
    p.sortDir = ''
  } else {
    p.sortDir = '-'
  }
  if (typeof params.page === 'undefined') {
    p.page = -1
  }
  // TODO: IS THIS UNUSED?
  /* if (typeof params.query === 'undefined') {
    p.query = ''
  } */
  let constrains = ''
  if (typeof params.constrains !== 'undefined' && p.constrains !== '') {
    Object.keys(params.constrains).forEach((key) => {
      constrains += `&_${key}=${params.constrains[key]}`
    })
  }
  p.constrains = constrains
  return p
}

export default (app) => {
  const store = generateStore('treasuryDocs', app)

  const url = humps.decamelize('treasuryDocs')
  store.actions.postListUnpaginated = function (context, ids) {
    return new Promise((resolve) => {
      //listRequestAbortControler.abort()
      const params = context.state.list.default.params
      const p = processParams(params)
      p.ids = ids
      //p.signal = listRequestAbortControler.signal
      context.commit('loadingUnpaginated', 'default')
      const fullURL = `${url}/search?_page=1&_limit=-1&_sort=${p.sortDir}${p.sortName}&_search=${params.search}${p.constrains}`
      axios
        .post(fullURL, p)
        .then((res) => {
          context.commit('clearErrors')
          context.commit('setListUnpaginated', { data: res.data.data, listName: 'default' }) // put on regular list
          context.commit('setIndexesUnpaginated', 'default')
          context.commit('loadedUnpaginated', 'default')
          context.commit('setLastStatus', res.status)
          resolve(res.data.data)
        })
        .catch((err) => {
          context.commit('clearErrors')
          if (err.response) {
            context.commit('setLastStatus', err.response.status)
            if (err.response.status === 404) {
              context.commit('loaded')
              resolve()
            } else {
              context.commit('notLoaded')
            }
          } else {
            context.commit('notLoaded')
          }
        })
    })
  }
  store.actions.copyToPaginated = function (context) {
    context.commit('clearList', 'default')
    context.commit('setList', {
      data: context.state.listUnpaginated.default.data,
      listName: 'default',
    })
  }

  store.actions.download = function (context, { ids, inBlocks }) {
    return new Promise((resolve) => {
      axios.post('treasury_docs/download', { ids, inBlocks }).then((res) => {
        resolve(res)
      })
    })
  }
  return store
}
